import { ADD_CAPACIDADES } from '../actions/actionTypes';

const initialState = {
    capacidades: [],
};

export const capacidadeReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CAPACIDADES:
            return {
                capacidades: action.capacidades,
            };

        default:
            return state;
    }
};
